import React from 'react';
import classNames from 'classnames';
import { NodeRowProps } from '../../types';
import useNodeInfo from '../../hooks/useNodeInfo';
import FileAccessCheckboxes from '../FileAccessCheckboxes';
import MymeTypeIcon from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/components/MymeTypeIcon';
import DataRoomNodeTagAndVersion from 'components/DataRoomNodeTagAndVersion';
import { getNodeMimeType } from 'utils';

import './FileNodeRow.styles.scss';

const FileNodeRow: React.FC<NodeRowProps> = (props) => {
  const { className, node, ...rest } = props;

  const { name, tag, version, _id } = node || {};

  const classes = classNames('file-node-row', className);

  const createInfoData = useNodeInfo();

  return (
    <div className={classes}>
      <div className="file-access-selector__node-info">
        <MymeTypeIcon mimeType={getNodeMimeType(node)} />
        <span>
          <p className="name">
            <span>{name}</span>
            <DataRoomNodeTagAndVersion tag={tag} version={version} />
          </p>
          {createInfoData(node)}
        </span>
      </div>

      <FileAccessCheckboxes id={_id} node={node} {...rest} />
    </div>
  );
};

export default FileNodeRow;
